module.exports = __webpack_public_path__ + "img/2-1.fcf1156e.svg";